var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0322,
    cy: 17.0322,
    r: 17.0322,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0322,
    cy: 17.0322,
    r: 16.5322,
    stroke: "#20484F",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.032 9.96509C13.1288 9.96509 9.93527 13.1515 9.93527 17.076C9.93527 20.6244 12.5327 23.5696 15.9249 24.1018V19.1341H14.1224V17.076H15.9249V15.5077C15.9249 13.7264 16.9823 12.747 18.6075 12.747C19.381 12.747 20.1901 12.8819 20.1901 12.8819V14.6348H19.2959C18.4159 14.6348 18.1391 15.1812 18.1391 15.7418V17.076H20.112L19.7927 19.1341H18.1391V24.1018C19.8114 23.8377 21.3342 22.9845 22.4326 21.6961C23.531 20.4077 24.1326 18.7691 24.1288 17.076C24.1288 13.1515 20.9352 9.96509 17.032 9.96509V9.96509Z",
    fill: "#072125"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.fc580ae21bdffd6172784a4246c0e310.svg";
export { ForwardRef as ReactComponent };